module.exports = __webpack_public_path__ + "img/dormakaba-component-md.c0dd7d84.svg";